import fertigationDataConfig from '@/api/config/fertigationDataConfig'
import { queryKeys } from '@/constant/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { getApiErrorMessage } from '@/helpers'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function deleteFertigation(
  interfaceId: string,
  id: string,
): Promise<void> {
  await fertigationDataConfig.delete(interfaceId, id)
}

function useDeleteFertigation() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeModal } = useConfigUI()

  return useMutation(
    (payload: { interfaceId: string; id: string }) =>
      deleteFertigation(payload.interfaceId, payload.id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.fertigation])
        toast.success(t('deleteFertigationSuccess'))
        closeModal()
      },
      onError: (error: any) => {
        // Any refusal the server explains (400 and 403 alike) is shown as it
        // came; the generic text is only for an error that carries none.
        toast.error(getApiErrorMessage(error, t('deleteFertigationError')))
      },
    },
  )
}

export default useDeleteFertigation
